import { useParams } from 'react-router';
import { itemIdRegex } from './utils';

export const useGetItemIdFromRouter = () => {
  const params = useParams();
  return params.itemId?.match(itemIdRegex)?.[0];
};
